import type { ButtonHTMLAttributes } from "react";
import { Pencil } from "lucide-react";
import { cn } from "@lib/utils/helpers";

interface EditIconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  iconClassName?: string;
}

export function EditIconButton({
  className,
  iconClassName,
  type = "button",
  title = "Edit",
  "aria-label": ariaLabel = "Edit",
  children,
  ...props
}: EditIconButtonProps) {
  return (
    <button
      type={type}
      title={title}
      aria-label={ariaLabel}
      className={cn(
        "inline-flex items-center justify-center rounded-full bg-transparent p-1 text-[#1597ff] transition hover:bg-[#1597ff]/10 hover:text-[#0d7acc] focus:outline-none focus:ring-2 focus:ring-[#1597ff]/30 disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      {...props}
    >
      {children ?? <Pencil className={cn("h-4 w-4", iconClassName)} aria-hidden />}
    </button>
  );
}
